// This data comes from the options ACF fields and is rendered in spektrix-custom-pathway.twig
const template = document.getElementById("pathwaySettings").content;

export const discountAvailable = {
    introduction: template.querySelector(
        "[basket-discount-available-introduction]",
    ),
    membership: template.querySelector(
        "[basket-discount-available-membership]",
    ),
};

export const BasketMembership = {
    id: template.querySelector("[basket-upsell-membership-id]"),
    title: template.querySelector("[basket-upsell-title]"),
    introduction: template.querySelector("[basket-upsell-intro]"),
    Thankstitle: template.querySelector("[basket-upsell-thanks-title]"),
    Thanksintroduction: template.querySelector(
        "[basket-upsell-thanks-message]",
    ),
};

export const noDiscountAvailable = {
    title: template.querySelector("[no-discount-available-title]"),
    introduction: template.querySelector(
        "[no-discount-available-introduction]",
    ),
    button: template.querySelector("[no-discount-available-button]"),
};

export const donationUpsell = {
    title: template.querySelector("[basket-donation-upsell-title]"),
    introduction: template.querySelector(
        "[basket-donation-upsell-introduction]",
    ),
    fund: template.querySelector("[basket-donation-upsell-fund]"),
    amount_from: template
        .querySelector("[basket-donation-upsell-amounts]")
        ?.getAttribute("from"),
    amount_to: template
        .querySelector("[basket-donation-upsell-amounts]")
        ?.getAttribute("to"),
    amount_donation: template
        .querySelector("[basket-donation-upsell-amounts]")
        ?.getAttribute("donation"),
};

export const additionalUpsell = {
    image: template.querySelector("[additional-donation-upsell-image]"),
    title: template.querySelector("[additional-donation-upsell-title]"),
    introduction: template.querySelector(
        "[additional-donation-upsell-introduction]",
    ),
    fund: template.querySelector("[additional-donation-upsell-fund]"),
    amounts: template
        .querySelector("[additional-donation-upsell-amounts]")
        ?.getAttribute("additional-donation-upsell-amounts"),
};

export const orderConfimation = {
    introduction: template.querySelector("[order-confirmation-introduction]"),
    button: template.querySelector("[order-confirmation-button]"),
    images: template.querySelector("[order-confirmation-images]"),
};

export const ticketDonations = {
    message: {
        title: template.querySelector("[ticket-donations-message-title]"),
        introduction: template.querySelector(
            "[ticket-donations-message-introduction]",
        ),
        content: template.querySelector("[ticket-donations-message-content]"),
    },
    fund: template.querySelector("[ticket-donations-fund]"),
    donation_max: template.querySelector("[ticket-donations-donation-max]"),
    thank_you_message: {
        title: template.querySelector("[donation-thank-you-message-title]"),
        content: template.querySelector("[donation-thank-you-message-content]"),
    },
};

export const account = {
    thank_you: {
        image: template.querySelector("[account-thank-you-image]"),
        title: template.querySelector("[account-thank-you-title]"),
        introduction: template.querySelector(
            "[account-thank-you-introduction]",
        ),
        button: template.querySelector("[account-thank-you-button]"),
    },

    overview_upsell: {
        image: template.querySelector("[account-upsell-image]"),
        title: template.querySelector("[account-upsell-title]"),
        introduction: template.querySelector("[account-upsell-introduction]"),
        button: template.querySelector("[account-upsell-button]"),
    },

    donation_history: {
        introduction: template.querySelector(
            "[account-donation-history-introduction]",
        ),
    },

    orders_upsell: {
        image: template.querySelector("[orders-upsell-image]"),
        title: template.querySelector("[orders-upsell-title]"),
        introduction: template.querySelector("[orders-upsell-introduction]"),
        button: template.querySelector("[orders-upsell-button]"),
    },

    membership_lapsed: {
        title: template.querySelector("[membership-lapsed-title]"),
        introduction: template.querySelector(
            "[membership-lapsed-introduction]",
        ),
    },

    personalised_offers: {
        offers: template.querySelectorAll("[personalised-offer]"),
    },

    discount_event_feed: {
        block: template.querySelector("[discount-event-feed]"),
    },

    membership_upsell: {
        block: template.querySelector("[memberships-upsell]"),
    },

    help_faqs: {
        block: template.querySelector("[help-faqs]"),
    },

    help_upsell: {
        image: template.querySelector("[help-upsell-image]"),
        title: template.querySelector("[help-upsell-title]"),
        introduction: template.querySelector("[help-upsell-introduction]"),
        button: template.querySelector("[help-upsell-button]"),
    },

    preferences_saved: {
        title: template.querySelector("[preferences-saved-title]"),
        introduction: template.querySelector(
            "[preferences-saved-introduction]",
        ),
    },

    preferences_not_saved: {
        title: template.querySelector("[preferences-not-saved-title]"),
        introduction: template.querySelector(
            "[preferences-not-saved-introduction]",
        ),
    },

    preferences_upsell: {
        image: template.querySelector("[preferences-upsell-image]"),
        title: template.querySelector("[preferences-upsell-title]"),
        introduction: template.querySelector(
            "[preferences-upsell-introduction]",
        ),
        button: template.querySelector("[preferences-upsell-button]"),
    },
};

export const seatingPlanColourOptions = {
    value: template.querySelector("[seating-plan-colour-set-by]"),
    colors: (() => {
        const script = template.querySelector("#seating-plan-colours-json");
        if (script) {
            try {
                return JSON.parse(script.textContent);
            } catch (e) {
                console.error("Could not parse seating plan colours JSON", e);
                return [];
            }
        }
        return [];
    })(),
};

export const concessionMessage = {
    text: template.querySelector("[concession-message]"),
};
